import React, { useEffect, useState } from 'react'
import OnlineFriend from '../onlinefriend/OnlineFriend'

const FriendRowMobile = ({friend}) => {

      const [sprite, setSprite] = useState(false)
      const [imgSize, setImgSize] = useState([])

      const is_sprite = (obj) => {
            if(obj.width % obj.height === 0 && obj.height === 80){
                  setSprite(true)
            }else{
                  setSprite(false)
            }
      }

      const get_image_size = (src) => {
            var imgObj = {}
            const img = new Image() 
            img.onload = () => {
                  imgObj.width = img.naturalWidth 
                  imgObj.height = img.naturalHeight 
                  imgObj.steps = (img.naturalWidth / img.naturalHeight) - 1 
                  imgObj.time = (img.naturalWidth / img.naturalHeight) / 10 
                  setImgSize(imgObj)
            }

            img.onerror = () => {
                  throw new Error('invalid image')
            }

            img.src = src
      }

      useEffect(() => {
            get_image_size(friend.avatar)
      }, [friend.avatar])

      useEffect(() => {
            if(imgSize.length !== 0){
                  is_sprite(imgSize)
            }
      }, [imgSize])

      if(imgSize.length === 0) return 

      const style = {
            backgroundImage: `url(${friend.avatar})`,
            backgroundPosition: 'left top',
            animation: `move_img ${imgSize.time}s steps(${imgSize.steps}) infinite`
      }

      return (
            <div className="friend_mobile__row" key={friend.name}>
                  <a href={friend.me} target="_blank" rel="noreferrer">
                        <div className="friend_mobile__avatar">
                              <div className="friend_mobile__avatar_img flex">
                                    {
                                          sprite 
                                                ? <div className="mobile_avatar__gif" style={style}></div>
                                                : <img src={friend.avatar} alt={friend.name} />
                                    }
                                    
                                    
                              </div>
                              <OnlineFriend id={friend.id_xat}/>
                        </div>
                        <div className="friend_mobile__info flex">
                              <span>{friend.name}</span>
                        </div>
                  </a>
            </div>
      )
}

export default FriendRowMobile
